import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

const siteUrl = 'https://gbwasap.org'

function canonical(path) {
	return `${siteUrl}${path}`
}

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp APK v18.80 Download for Android (2026)',
			keywords: 'gbwhatsapp, gb whatsapp, gb whatsapp download, gb whatsapp apk',
			description: 'Download GB WhatsApp APK v18.80 for Android. Check APK info, features, installation steps, safety risks, chat transfer, old versions, and alternatives.',
			link: [
				{
					rel: 'canonical',
					href: canonical('/'),
				},
			],
		},
		component: Home,
	},
	{
		path: '/download',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Safe Page to Get GB WhatsApp APK New Version',
			keywords: 'gbwhatsapp apk download, gb whatsapp apk download, gbwhatsapp download, gb whatsapp download',
			description: "Visit this page to get the latest GBWhatsApp APK file. We'll update it once new version released. It's safe and for free.",
			link: [
				{
					rel: 'canonical',
					href: canonical('/download/'),
				},
			],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/privacy',
		name: 'en-privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy Policy - gbwasap.org',
			keywords: 'gbwasap privacy policy, gb whatsapp privacy policy',
			description: 'Read the gbwasap.org privacy policy and learn how this independent information website handles basic visitor information.',
			legalKey: 'privacy',
			link: [
				{
					rel: 'canonical',
					href: canonical('/privacy/'),
				},
			],
		},
		component: () => import('@/views/legal.vue'),
	},
	{
		path: '/disclaimer',
		name: 'en-disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Disclaimer - gbwasap.org',
			keywords: 'gbwasap disclaimer, gb whatsapp disclaimer',
			description: 'Read the gbwasap.org disclaimer. This site shares GB WhatsApp information and is not the developer or an official WhatsApp service.',
			legalKey: 'disclaimer',
			link: [
				{
					rel: 'canonical',
					href: canonical('/disclaimer/'),
				},
			],
		},
		component: () => import('@/views/legal.vue'),
	},
	{
		path: '/about-us',
		name: 'en-about',
		meta: {
			appname: 'GBWhatsApp',
			title: 'About Us - gbwasap.org',
			keywords: 'about gbwasap, about gb whatsapp apk site',
			description: 'Learn about gbwasap.org, an independent website sharing GB WhatsApp APK information, setup guidance, safety notes, and troubleshooting tips.',
			legalKey: 'about',
			link: [
				{
					rel: 'canonical',
					href: canonical('/about-us/'),
				},
			],
		},
		component: () => import('@/views/legal.vue'),
	},
	{
		path: '/contact-us',
		name: 'en-contact',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Contact Us - gbwasap.org',
			keywords: 'contact gbwasap, gb whatsapp apk contact',
			description: 'Contact gbwasap.org at support@gbwasap.org for website questions, corrections, or general feedback.',
			legalKey: 'contact',
			link: [
				{
					rel: 'canonical',
					href: canonical('/contact-us/'),
				},
			],
		},
		component: () => import('@/views/legal.vue'),
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes: constRoutesPc,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			return { x: 0, y: 0 }
		},
	})
}
